import DefaultPage from "./default";
import RedirectPage from "./redirect";
import SurveyPage from "./survey";

export default {
  default: DefaultPage,
  redirect: RedirectPage,
  survey: SurveyPage,
};
